import { debounce } from "throttle-debounce";

export default {
  methods: {
    ticketCost(ticket, discountValid, forSingleTicket = false) {
      var self = this;
      var ticketCost = ticket.cost_b;
      if (discountValid) {
        ticketCost = ticket.cost_a;
      }
      return (
        ticketCost -
        self.ticketDiscountAmount(ticket, discountValid, forSingleTicket)
      );
    },

    getVatRate(ticket) {
      var vatRate = (this.vatRatePercent | 20) / 100;
      if (ticket.vat_rate) {
        this.vatRate = ticket.vat_rate.rate;
      }
      return vatRate;
    },

    ticketVatExc(ticket, discountValid, forSingleTicket = false) {
      var self = this;
      var ticketCost = ticket.cost_b;
      if (discountValid) {
        ticketCost = ticket.cost_a;
      }
      var vatRate = this.getVatRate(ticket);
      return (
        (ticketCost -
          self.ticketDiscountAmount(ticket, discountValid, forSingleTicket)) *
        vatRate
      );
    },

    ticketDiscountAmount(ticket, discountValid, forSingleTicket = false) {
      var ticketCost = ticket.cost_b;
      if (!ticket.discount_type) {
        return 0;
      }

      var ticketCost = ticket.cost_b;
      if (discountValid) {
        ticketCost = ticket.cost_a;
      }

      if (!forSingleTicket) ticketCost = ticketCost * ticket.quantity_tickets;

      if (ticket.discount_type == "percentage") {
        var discAmount = (ticket.discount_amount / 100) * ticketCost;
        ticket.total_discount = discAmount;
        return discAmount;
      } else {
        var discAmount = ticket.discount_amount * ticket.quantity_tickets;
        ticketCost = ticketCost - discAmount;
        if (ticketCost < 0) {
          return 0;
        } else {
          ticket.total_discount = discAmount;
          return discAmount;
        }
      }

      // TODO apply to ticket
    },

    totalCost(tickets, discountValid, forSingleTicket = false) {
      var total = 0;
      var self = this;

      tickets.forEach(ticket => {
        var ticketCost = ticket.cost_b;
        if (discountValid) {
          ticketCost = ticket.cost_a;
        }

        total +=
          (ticketCost -
            self.ticketDiscountAmount(ticket, discountValid, forSingleTicket)) *
          ticket.quantity_tickets;
      });

      return total;
    },

    totalCostWithDiscount(total, event_booking){
      if (event_booking.discount_code_id) {
        total = total - (total / 100) * event_booking.discount_percentage;
      }
      return total;
    },

    totalCostForNonCard(
      tickets,
      discount_percentage,
      discountValid,
      forSingleTicket = false
    ) {
      var self = this;
      var total = 0;

      tickets.forEach(ticket => {
        var ticketCost = ticket.cost_b;
        if (discountValid) {
          ticketCost = ticket.cost_a;
        }

        total +=
          (ticketCost -
            self.ticketDiscountAmount(ticket, discountValid, forSingleTicket)) *
          ticket.quantity_tickets;
      });

      if (discount_percentage) {
        var subtotal = total;
        total = total - (subtotal / 100) * discount_percentage;
      }

      return total;
    },

    totalVatExc(tickets, discountValid, forSingleTicket = false) {
      var total = 0.0;
      var self = this;

      tickets.forEach(ticket => {
        var ticketCost = ticket.cost_b;
        if (discountValid) {
          ticketCost = ticket.cost_a;
        }

        total +=
          ((ticketCost -
            self.ticketDiscountAmount(ticket, discountValid, forSingleTicket)) *
          (self.getVatRate(ticket) / 100)) * ticket.quantity_tickets;
      });
      return total;
    }
  }
};
